import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from './pages/Homepage';
import Products from './pages/Products/Products'
import IndividualProduct from './pages/Products/IndividualProduct'
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import NotFound from "./pages/util/NotFound";
import Cart from "./pages/Cart";
import MyOrders from "./pages/User/MyOrders";
import UserDetails from "./pages/User/UserDetails";
import Wishlist from "./pages/User/Wishtlist";
import Addresses from "./pages/User/Addresses";
import PrivateRoute from "./utility/PrivateRoute";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import Checkoute from "./pages/Checkout/Checkoute";
import Payments from "./pages/Checkout/Payments";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<Homepage />} />
        {/* Product */}
        <Route exact path='/collections/framed-art' element={<Products/>} />
        <Route exact path='/collections/framed-art/products/:handle' element={<IndividualProduct/>} />
        {/* Cart */}
        <Route exact path='/cart' element={<Cart/>} />
        {/* User */}
        <Route element={<PrivateRoute/>}>
          <Route exact path='/user/myorders' element={<MyOrders/>} />
          <Route exact path='/user/wishlist' element={<Wishlist/>} />
          <Route exact path='/user/me' element={<UserDetails/>} />
          <Route exact path='/user/addresses' element={<Addresses/>} />
          {/* Checkoute */}
          <Route exact path='/checkout' element={<Checkoute/>} />
          <Route exact path='/payments/:orderId' element={<Payments/>} />
        </Route>
        {/* Auth */}
        <Route exact path='/login' element={<Login/>} />
        <Route exact path='/register' element={<Register/>} />
        <Route exact path='/forgotpassword' element={<ForgotPassword/>} />
        <Route exact path='/resetpassword/:token' element={<ResetPassword/>} />
        {/* Others */}
        <Route path='*' element={<NotFound/>} />
      </Routes>
    </Router>
  );
}

export default App;
